import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { categories, getCategoryBySlug } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

const categoryArticleImages: Record<string, string> = {
  '1': 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20displaying%20a%20colorful%20shopping%20app%20interface%20with%20warm%20ambient%20lighting%2C%20minimalist%20flat%20lay%20composition%20with%20soft%20pink%20and%20cream%20tones%2C%20clean%20product%20photography%20style%2C%20gentle%20natural%20light%20from%20window%2C%20elegant%20lifestyle%20aesthetic&width=800&height=480&seq=cat-article-1&orientation=landscape',
  '2': 'https://readdy.ai/api/search-image?query=A%20warm-toned%20customer%20service%20workspace%20setup%20with%20a%20laptop%20showing%20support%20chat%20interface%2C%20phone%20and%20headset%20on%20a%20clean%20desk%2C%20soft%20natural%20lighting%20through%20sheer%20curtains%2C%20minimalist%20and%20professional%20atmosphere&width=800&height=480&seq=cat-article-2&orientation=landscape',
  '3': 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20displaying%20a%20package%20tracking%20interface%20with%20delivery%20route%20map%2C%20placed%20on%20a%20clean%20wooden%20desk%20with%20a%20cup%20of%20tea%20nearby%2C%20warm%20natural%20morning%20light%2C%20minimalist%20lifestyle%20composition&width=800&height=480&seq=cat-article-3&orientation=landscape',
  '4': 'https://readdy.ai/api/search-image?query=A%20diverse%20group%20of%20smartphones%20and%20tablets%20displaying%20various%20social%20media%20app%20icons%20on%20their%20screens%2C%20arranged%20on%20a%20warm%20cream-colored%20surface%2C%20soft%20diffused%20lighting&width=800&height=480&seq=cat-article-4&orientation=landscape',
  '5': 'https://readdy.ai/api/search-image?query=A%20vibrant%20shopping%20promotion%20flat%20lay%20with%20gift%20boxes%2C%20discount%20tags%2C%20and%20shopping%20bags%20in%20soft%20pastel%20pink%20and%20gold%20tones%2C%20elegant%20and%20festive%20composition&width=800&height=480&seq=cat-article-5&orientation=landscape',
  '6': 'https://readdy.ai/api/search-image?query=A%20clean%20and%20organized%20desk%20setup%20with%20a%20return%20package%20and%20shipping%20label%20ready%20to%20be%20sent%2C%20surrounded%20by%20packing%20materials%20and%20tape%20dispenser%2C%20soft%20window%20light&width=800&height=480&seq=cat-article-6&orientation=landscape',
  '7': 'https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20a%20security%20lock%20icon%20on%20screen%2C%20placed%20on%20a%20clean%20light-colored%20desk%20surface%2C%20soft%20natural%20side%20lighting%20creating%20gentle%20shadows%2C%20minimalist%20cybersecurity%20concept&width=800&height=480&seq=cat-article-7&orientation=landscape',
  '8': 'https://readdy.ai/api/search-image?query=A%20bright%20and%20cheerful%20family%20carnival%20scene%20with%20colorful%20balloons%20and%20activity%20booths%20in%20a%20modern%20indoor%20venue%2C%20families%20with%20children%20enjoying%20various%20games%2C%20warm%20natural%20light&width=800&height=480&seq=cat-article-8&orientation=landscape',
  '9': 'https://readdy.ai/api/search-image?query=A%20flat%20lay%20of%20various%20payment%20methods%20represented%20by%20smartphone%20screens%20showing%20payment%20interfaces%2C%20next%20to%20a%20wallet%20and%20credit%20cards%2C%20warm%20soft%20lighting%2C%20clean%20minimalist%20composition&width=800&height=480&seq=cat-article-9&orientation=landscape',
  '10': 'https://readdy.ai/api/search-image?query=A%20elegant%20membership%20card%20display%20on%20a%20soft%20pink%20gradient%20background%2C%20with%20gold%20accents%20and%20premium%20card%20designs%20layered%20beautifully%2C%20warm%20diffused%20lighting%20creating%20a%20luxurious%20atmosphere&width=800&height=480&seq=cat-article-10&orientation=landscape',
  '11': 'https://readdy.ai/api/search-image?query=A%20modern%20open-plan%20office%20space%20with%20a%20large%20screen%20displaying%20strategic%20growth%20charts%2C%20team%20of%20diverse%20professionals%20collaborating%20at%20a%20meeting%20table%2C%20warm%20natural%20light%20through%20windows&width=800&height=480&seq=cat-article-11&orientation=landscape',
  '12': 'https://readdy.ai/api/search-image?query=A%20beautifully%20wrapped%20gift%20box%20with%20elegant%20ribbon%20and%20a%20decorative%20gift%20card%20placed%20on%20top%2C%20soft%20pastel%20pink%20background%20with%20subtle%20floral%20elements%2C%20warm%20diffused%20lighting%20from%20above&width=800&height=480&seq=cat-article-12&orientation=landscape',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = getCategoryBySlug(slug || '');
  const articles = getArticlesByCategory(slug || '');

  if (!category) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="pt-20 pb-20 text-center">
          <h1 className="text-2xl font-bold text-foreground-950">分类不存在</h1>
          <Link to="/" className="text-primary-500 hover:text-primary-600 mt-4 inline-block whitespace-nowrap">
            返回首页
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const catJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 蜜芽永不失联`,
    description: category.description,
    url: `https://miya-official.com/category/${category.slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '蜜芽永不失联',
      url: 'https://miya-official.com',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(catJsonLd) }}
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        <main className="pt-20 pb-14">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: category.name },
              ]}
            />

            <div className="mb-10">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${category.icon} text-xl`}></i>
                </div>
                <div>
                  <h1 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                    {category.name}
                  </h1>
                  <p className="text-sm text-foreground-600 mt-1">
                    {category.description}
                  </p>
                </div>
              </div>
            </div>

            <div className="flex gap-3 mb-8 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                    cat.slug === category.slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {articles.length === 0 ? (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类下暂无文章</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {articles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="group bg-background-50 rounded-lg overflow-hidden transition-all hover:-translate-y-1 cursor-pointer"
                  >
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={categoryArticleImages[article.id] || categoryArticleImages['1']}
                        alt={article.title}
                        title={`${article.title} - 蜜芽永不失联`}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-4 md:p-5">
                      <div className="flex items-center gap-3 mb-2">
                        <span className="text-xs text-foreground-500">{article.date}</span>
                      </div>
                      <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2">
                        {article.title}
                      </h3>
                      <p className="text-xs md:text-sm text-foreground-600 mt-2 line-clamp-2">
                        {article.summary}
                      </p>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}